import styled from '@emotion/styled';
import Dialog from '@/components/Dialog';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import mediaQuery from '@/lib/styling/mediaQuery';

const StyledDialog = styled(Dialog)(
  {
    '.MuiDialog-paper': {
      width: 'auto',
      maxWidth: 1240,
      display: 'block',
      [mediaQuery(1450)]: {
        maxWidth: 'calc(90% - 64px)',
      },
      [mediaQuery(1100)]: {
        maxWidth: 'calc(100% - 64px)',
      },
      [mediaQuery(480)]: {
        maxWidth: 'calc(100% - 24px)',
      },
    },
    '.MuiDialogContent-root': {
      padding: 0,
      display: 'flex',
      justifyContent: 'center',
      boxSizing: 'border-box',
      img: {
        maxWidth: '100%',
      },
    },
  },
  addHighContrastStyles(({ theme }) => ({
    '.MuiDialog-paper': {
      border: `2px solid ${theme.palette.divider}`,
    },
  })),
);

export default StyledDialog;
